import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AttendanceCalendar from "../../components/Attendance/components/Calendar";
import Card from "../../components/ui/Card";
import axios from "../../axios";

function Attendance() {
  const location = useLocation();
  const navigate = useNavigate();
  const isStandalone = location.pathname === "/attendance";

  const [showCalendar, setShowCalendar] = useState(location.state?.autoShowCalendar || false);
  const [confirmedTuitions, setConfirmedTuitions] = useState([]);
  const [selectedTuition, setSelectedTuition] = useState(location.state?.tuition || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfirmedTuitions();
  }, []);

  const fetchConfirmedTuitions = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/v1/attendance/confirmed-tuitions");
      if (response.data.is_success) {
        setConfirmedTuitions(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching confirmed tuitions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAttendance = (tuition) => {
    setSelectedTuition(tuition);
    setShowCalendar(true);
  };

  const renderContent = () => (
    <>
      {!showCalendar && (
        <div className="attendance-cards-container" style={{ display: "flex", flexDirection: "column", gap: "20px", padding: isStandalone ? "20px 0" : "0" }}>
          {confirmedTuitions.length > 0 ? (
            confirmedTuitions.map((tuition) => (
              <Card
                key={tuition.deal_id}
                tuition={tuition}
                onMarkAttendance={() => handleMarkAttendance(tuition)}
              />
            ))
          ) : (
            <div style={{ padding: "40px", textAlign: "center", color: "#666" }}>No confirmed tuitions found.</div>
          )}
        </div>
      )}
      {showCalendar && (
        <AttendanceCalendar
          tuition={selectedTuition}
          onBack={() => setShowCalendar(false)}
        />
      )}
    </>
  );

  if (loading) {
    const loadingEl = <div style={{ padding: "20px", textAlign: "center" }}>Loading your tuitions...</div>;
    return isStandalone ? <main className="main">{loadingEl}</main> : loadingEl;
  }

  if (isStandalone) {
    return (
      <main className="main">
        <section className="pathway-requestBtn--wrapper">
          <div className="pathway--wrapper">
            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/dashboard");
              }}
            >
              <img src="/homeicon.svg" alt="homeicon icon" width="18" height="17" />
            </div>
            <div>
              <img src="/rightArrow.svg" alt="rightArrow icon" width="11" height="11" />
            </div>
            <div
              className="pathway--btn"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/my-profile");
              }}
            >
              Account
            </div>
            <div>
              <img src="/rightArrow.svg" alt="rightArrow icon" width="11" height="11" />
            </div>
            <div className="pathway--btn">Attendance</div>
          </div>
        </section>
        <div style={{ paddingBottom: "40px" }}>
          {renderContent()}
        </div>
      </main>
    );
  }

  return renderContent();
}

export default Attendance;